export default {
    softwaresSelectionArea: {
        width: "100%",
        marginBottom: "50px",
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
    },
    checkboxItem: {
        flex: "50%",
        padding: "10px"
    }
}